module.exports = __webpack_public_path__ + "img/1321203327.fd28eef5.jpg";